var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cloud-holder-wrapper-main"
  }, [!_vm.openOnLoad ? _c('div', {
    staticClass: "holder-header-wrapper"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })]) : _vm._e(), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened ? _c('div', _vm._l(_vm.clouds, function (cloud, key) {
    return _c('document-cloud-item', {
      key: key,
      attrs: {
        "type": _vm.type,
        "extra": _vm.extra,
        "open-on-load": _vm.clouds.length < 6,
        "cloud": cloud,
        "meta-data": _vm.metaData
      }
    });
  }), 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }